import React, { FC } from 'react';

export const MobileSeparator: FC = () => {
  return (
    <div className="h-5 pt-5 -m-6 bg-primary-100 border-t-2 border-primary-200 sm:hidden"></div>
  );
};
